import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import Routes from './routes';
import { GoogleOAuthProvider } from '@react-oauth/google';

const App = () => (
  <GoogleOAuthProvider clientId="936727868630-2hmobol1nifi3rsvq88ah5cp42pph198.apps.googleusercontent.com">
    <Router>
      <Routes />
    </Router>
  </GoogleOAuthProvider>
);

export default App;

